import { Link } from 'react-router-dom';
import SectionTitle from '@/components/base/SectionTitle';
import Reveal from '@/components/base/Reveal';
import TopicCard from '@/components/feature/TopicCard';
import { topics } from '@/mocks/topics';

export default function FeaturedTopics() {
  const featured = topics.slice(0, 6);

  return (
    <section className="w-full bg-background-50 py-14 md:py-20" id="topics">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <Reveal>
          <SectionTitle
            eyebrow="Now Trending"
            title="正在发酵的话题"
            desc="挑几个还在持续讨论的话题，点进去看时间脉络、各方观点和评论区实录。"
            action={
              <Link
                to="/topics"
                className="flex cursor-pointer items-center gap-1 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                浏览全部
                <i className="ri-arrow-right-line" />
              </Link>
            }
          />
        </Reveal>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {featured.map((topic, i) => (
            <Reveal key={topic.id} delay={i * 50} className="h-full">
              <TopicCard topic={topic} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}